import { Fragment, useState } from "react";
import { Grid, Typography } from "@mui/material";

import List from "./List";
import AddNewAgentDialog from "./AddNewAgentDialog";
import { PageHeader } from "../../../components";
import { PrimaryButton } from "../../css components/Button";
import { colors } from "../../css components/Style";

export default function Form({ setColumns, setAgents, columns, agents }) {
  const [dialogState, setDialogState] = useState({ state: false, data: {} });
  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid size={12}>
          <PageHeader
            title="Delivery Channel Settings"
            pageName={"Delivery Channel Agents"}
            pageHeader="View and manage agents assigned to each communication channel."
            buttons={[
              <PrimaryButton
                variant="contained"
                onClick={() =>
                  setDialogState({
                    state: true,
                    agents: agents,
                    create: true,
                    data: {
                      channel_id: "",
                    },
                  })
                }
              >
                Add Agent
              </PrimaryButton>,
            ]}
          />
        </Grid>

        {agents?.map((agent) => (
          <Grid size={12} key={agent.channelID}>
            <List
              name={agent.channelName}
              agent={agent[agent.channelName]}
              fields={columns[agent.channelID]}
              setDialogState={setDialogState}
              agentInfo={{
                agentName: agent.channelName,
                logo: agent.channelLogo,
              }}
            />
          </Grid>
        ))}

        {agents.length === 0 && (
          <Grid size={12} style={{ textAlign: "center" }}>
            <Typography variant="h4" color={colors.green}>
              No agents found.
            </Typography>
          </Grid>
        )}
      </Grid>

      <AddNewAgentDialog
        setColumns={setColumns}
        setAgents={setAgents}
        dialogState={dialogState}
        setDialogState={setDialogState}
      />
    </Fragment>
  );
}
